import { Button, Center, FormControl, FormLabel, Heading, Input, useToast, VStack, Spinner, Box } from "@chakra-ui/react";
import { fetcher, AdminSegmentEndpoints } from "@olagg/api-hooks";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../consts/routes";

const EditSegment = () => {
  const { id } = useParams<{ id: string }>();
  const [segmentName, setSegmentName] = useState('');
  const [segmentDescription, setSegmentDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetchingSegment, setFetchingSegment] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSegment = async () => {
      try {
        const segment = await fetcher(AdminSegmentEndpoints.find(Number(id)));
        setSegmentName(segment.name);
        setSegmentDescription(segment.description);
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar el segmento',
          status: 'error',
          position: 'bottom-right'
        });
        navigate(ROUTES.SEGMENTS.all);
      } finally {
        setFetchingSegment(false);
      }
    };

    if (id) {
      fetchSegment();
    }
  }, [id]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await fetcher(AdminSegmentEndpoints.update(Number(id), {
      name: segmentName,
      description: segmentDescription
    }))
    .then(() => {
      toast({
        title: 'Segmento actualizado',
        colorScheme: 'olaggPink',
        status: 'success',
        description: 'El segmento se ha actualizado correctamente.',
        position: 'bottom-right'
      })
      navigate(ROUTES.SEGMENTS.all)
    })
    .catch(e => {
      toast({
        title: 'Error al actualizar el segmento',
        colorScheme: 'olaggPink',
        status: 'error',
        description: 'Ha ocurrido un error al actualizar el segmento, por favor intente de nuevo.',
        position: 'bottom-right'
      })
    })
    .finally(() => {
      setLoading(false);
    })
  }

  if (fetchingSegment) {
    return (
      <Center w={'full'} p={4}>
        <Box height='300px' display='flex' justifyContent='center' alignItems='center'>
          <Spinner color="white" />
        </Box>
      </Center>
    );
  }

  return (
    <Center w={'full'} p={4} >
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Editar segmento
        </Heading>
        <form onSubmit={handleSubmit}>
          <FormControl id="name" isRequired>
            <FormLabel>Nombre</FormLabel>
            <Input type="text" value={segmentName} onChange={(e) => setSegmentName(e.target.value)} />
          </FormControl>
          <FormControl id="description" isRequired>
            <FormLabel>Descripción</FormLabel>
            <Input type="text" value={segmentDescription} onChange={(e) => setSegmentDescription(e.target.value)} />
          </FormControl>
          <Button
            type="submit"
            variant='filledGradient'
            isLoading={loading}
            loadingText="Actualizando segmento"
            my={4}
          >
            Actualizar segmento
          </Button>
        </form>
      </VStack>
    </Center>
  )
}

export default EditSegment;
